<template>
  <form
    class="filter filter--block"
    @submit.prevent="$emit('submit', $event)"
  >
    <slot></slot>
  </form>
</template>

<script>
  export default {
    props: {
      need_margin: {
        type: Boolean,
        default: true
      }
    }
  };
</script>
